import { put } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "rdx/modules/preferredPartners/messages";

function* deletePreferredPartner(action) {
  const { id, deleteFromAdminView = false, search } = action.payload;

  const { success, data, error } = yield* makeRequest.delete(`/enterprise_labor_partners/${id}`);

  if (success && data) {
    if (deleteFromAdminView) {
      yield put(actions.getPreferredPartnersAdmin(search));
    }
    yield put(actions.newSuccessEvent({ message: messages.REMOVE_PREFERRED_PARTNER_SUCCESS }));
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.ERROR_REMOVING_PREFERRED_PARTNER,
    });
  }

  return null;
}

export default deletePreferredPartner;
